import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './FindProduct';

const FindProductSuspense = dynamic(() => import('./FindProduct'), {
	loading: () => <BlockLoadingSpinner />,
});

export default function DynamicFindProduct(props: Props) {
	return <FindProductSuspense {...props} />;
}
DynamicFindProduct.displayName = 'DynamicFindProduct';
